import { render } from "./CourseCompleted.vue?vue&type=template&id=77a2eee5"
import script from "./CourseCompleted.vue?vue&type=script&lang=js"
export * from "./CourseCompleted.vue?vue&type=script&lang=js"

import "./CourseCompleted.vue?vue&type=style&index=0&id=77a2eee5&lang=scss"

import exportComponent from "/home/los7/Documents/Sites/IntendedMe/Front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__